<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Admin.list.Search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Admin.list.Name') }}</label>
                        <InputText id="title" :value="name" type="text" :placeholder="$t('Admin.list.SBName')" v-model="name" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Admin.list.Email') }}</label>
                        <InputText id="title" :value="email" type="text" :placeholder="$t('Admin.list.SBEmail')" v-model="email" />
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0"></div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchAdmin"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetAdmin"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('Admin.list.RecruiterList') }}</h5>
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mb-2 p-flex-column p-flex-lg-row">
                    <!-- <div>

                    </div> -->
                    <div class="p-mb-4 p-mb-lg-0 page">
                        <label for="order"
                            >{{ $t('inquiry.list.Record') }}: {{ pagination.total_records }}
                            <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                        </label>
                    </div>
                    <router-link :to="'/AdminManagement/AddAdmin'">
                        <Button label="Primary" class="p-mr-2 p-mb-2 p-button1">{{ $t('Admin.list.AddNew') }}</Button>
                    </router-link>
                </div>

                <br />

                <DataTable :value="users" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- F*** the CODE........... -->
                    <ColumnGroup type="header">
                        <Row>
                            <Column :header="$t('Admin.list.No')" :rowspan="2" />
                            <Column :header="$t('Admin.list.Name')" :rowspan="2" />
                            <Column :header="$t('Admin.list.Email')" :rowspan="2" />
                            <Column :header="$t('Admin.list.Phone')" :rowspan="2" />
                            <Column :header="$t('Admin.list.Menuauthorization')" :colspan="9" />
                            <Column :header="$t('Admin.list.Action')" :rowspan="2" />
                        </Row>
                        <Row>
                            <Column :header="$t(`Member Statistics`)" field="MemberStatistics" style="min-width: 12rem" />
                            <Column :header="$t(`Member Management`)" field="MemberManagement" style="min-width: 12rem" />
                            <Column :header="$t(`Purchase Management`)" field="PurchaseManagement" style="min-width: 12rem" />
                            <Column :header="$t(`Paid Feature Management`)" field="PaidFeatureManagement" style="min-width: 12rem" />
                            <Column :header="$t(`Board Management`)" field="BoardManagement" style="min-width: 12rem" />
                            <Column :header="$t(`Information Management`)" field="InformationManagement" style="min-width: 12rem" />
                            <Column :header="$t(`Labor Counsel`)" field="LaborCounsel" style="min-width: 12rem" />
                            <Column :header="$t(`Post From Other Platform Request`)" field="PostFromOtherPlatformRequest" style="min-width: 12rem" />
                            <Column :header="$t(`Position Offer`)" field="PositionOffer" style="min-width: 12rem" />
                        </Row>
                    </ColumnGroup>
                    <!-- F*** the CODE........... -->

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('Admin.list.No')" style="min-width: 4rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('Admin.list.Name')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            {{ data.name }}
                        </template>
                    </Column>
                    <Column :header="$t('Admin.list.Email')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Email</span>
                            {{ data.email }}
                        </template>
                    </Column>
                    <Column :header="$t('Admin.list.Phone')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Phone</span>
                            {{ formatPhoneNumber(data.phone_number) }}
                        </template>
                    </Column>

                    <!-- F*** the CODE........... -->
                    <Column field="MemberStatistics">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'member_statistics' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'member_statistics' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="MemberManagement">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'member_management' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'member_management' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="PurchaseManagement">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'purchase_management' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'purchase_management' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="PaidFeatureManagement">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'paid_feature_management' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'paid_feature_management' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="BoardManagement">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'board_management' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'board_management' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="InformationManagement">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'information_management' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'information_management' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="LaborCounsel">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'labor_counsel' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'labor_counsel' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="PostFromOtherPlatformRequest">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'post_from_other_platform_request' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'post_from_other_platform_request' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="PositionOffer">
                        <template #body="{ data }">
                            <div v-for="item of data.menus" :key="item.menu_alias">
                                <!-- {{data.name}} -->
                                <i v-if="item.menu_alias == 'position_offer' && item.status == 'active'" class="pi pi-check" style="font-size: 1.5rem"></i>
                                <i v-else-if="item.menu_alias == 'position_offer' && item.status == 'inactive'" class="pi pi-times" style="font-size: 1.5rem"></i>
                            </div>
                        </template>
                    </Column>
                    <!-- F*** the CODE........... -->

                    <Column :header="$t('Admin.list.Action')" style="width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <!-- <router-link :to="'/ViewRecruiter/'"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link> -->
                                <router-link :to="'/AdminManagement/EditAdmin/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i> </Button> </router-link
                                >&nbsp;
                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';/
// import {AdminService} from '@/service/API/AdminService';
// import axios from 'axios';
import 'primeicons/primeicons.css';
import AdminService from '../../service/API/AdminService';
import utils from '@/service/utils';
// import { AdminService } from '@/service/API/AdminService.js';
import axios from 'axios';
export default {
    data() {
        return {
            storedNameValue: '',
            loading1: false,
            products: null,
            expandedRows: [],
            users: [],

            dropdownItem: null,
            error: {},
            //params for list

            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            name: '',
            email: '',
            phone_number: '',
            user: {
                menus: [],
            },
        };
    },
    // customerService: null,
    AdminService: null,
    created() {
        // this.storedNameValue = localStorage.getItem('nameSearch');
        // this.storedEmailValue = localStorage.getItem('emailSearch');
        // this.name = this.storedNameValue;
        // this.email = this.storedEmailValue;
        this.adminService = new AdminService();
        // let searchParams = {
        //     limit: this.pagination.pagination_limit,
        //     page: 1,
        //     email: this.storedEmailValue,
        //     name: this.storedNameValue,
        // };
        // this.callAPI(searchParams);
    },
    mounted() {
        this.storageData = localStorage.getItem('AdminManagement') ? JSON.parse(localStorage.getItem('AdminManagement')) : '';

        if (this.storageData != '') {
            this.AdminListPagination = this.storageData.current_page;
            this.name = this.storageData.name == undefined ? '' : this.storageData.name;
            this.email = this.storageData.email == undefined ? '' : this.storageData.email;
        }
        if (this.AdminListPagination == '' || this.AdminListPagination == null) {
            if (this.name || this.email) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    name: this.storageData.name == undefined ? '' : this.storageData.name,
                    email: this.storageData.email == undefined ? '' : this.storageData.email,
                };
                this.getlist(searchLocalParams);
            } else {
                this.getlist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.AdminListPagination,
                limit: this.pagination.pagination_limit,
                name: this.storageData.name == undefined ? '' : this.storageData.name,
                email: this.storageData.email == undefined ? '' : this.storageData.email,
            };
            this.getlist(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getlist({ limit: val, page: 1 });
        },
    },
    methods: {
        // callAPI(val) {},
        getlist(data) {
            // const adminlistParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            // };
            this.loading1 = true;
            this.adminService
                .getAdminList(data)
                .then((res) => {
                    this.users = res.data.user;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                })
                .catch(() => {
                    this.users = [];
                    this.loading1 = false;
                });
            // this.callAPI(adminlistParams);
        },

        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading = true;
            localStorage.setItem(
                'AdminManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    email: this.email,
                    name: this.name,
                })
            );
            this.adminService
                .getAdminList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    name: this.name,
                    email: this.email,
                })
                .then((res) => {
                    this.users = res.data.user;
                    this.pagination.current_page = page;
                    this.loading = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },

        resetAdmin() {
            // localStorage.setItem('nameSearch', '');
            // localStorage.setItem('emailSearch', '');
            this.name = '';
            this.email = '';
            // const obj = {
            //     name: '',
            //     email: '',
            //     limit: this.pagination.pagination_limit,
            // };
            // this.callAPI(obj);
            localStorage.setItem('AdminManagement', '');
            this.getlist();
            window.location.reload();
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            } else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            } else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
        searchAdmin() {
            // const nameSearchValue = localStorage.getItem('nameSearch');
            if (this.name == '' && this.email == '') {
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                localStorage.setItem(
                    'AdminManagement',
                    JSON.stringify({
                        page: 1,
                        // limit: this.pagination.pagination_limit,
                        email: this.email,
                        name: this.name,
                    })
                );
                // localStorage.setItem('nameSearch', this.name);
                // localStorage.setItem('emailSearch', this.email);
                let searchParams = {
                    pagination_limit: this.pagination.pagination_limit,
                    page: 1,
                    email: this.email,
                    name: this.name,
                };
                this.loading = true;
                this.adminService
                    .getAdminList(searchParams)
                    .then((res) => {
                        this.users = res.data.user;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading1 = false;
                        console.log(res.data);
                    })
                    .catch((err) => console.log(err));
                // this.callAPI(searchParams);
            }
        },

        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'get', url: `/api/v1/admin/user/admin-delete/${id}` }).then(function () {});
                    this.getlist();
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background-color: white;
    color: black;
    // border-color: black;
}

//  button.p-button.p-component.p-button2 {
//     background: white;
//     border: 1px white;
//     --surface-hover: blue;
//     color: black;
// }
</style>
